import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Group {
    id: string;
    name: string;
    code: string;
    description?: string;
    color?: string;
    createdAt: string;
}

interface GroupState {
    groups: Group[];
    loading: boolean;
    error: string | null;
}

const initialState: GroupState = {
    groups: [],
    loading: false,
    error: null,
};

const groupSlice = createSlice({
    name: 'Group',
    initialState,
    reducers: {
        setGroups: (state, action: PayloadAction<Group[]>) => {
            state.groups = action.payload;
            state.loading = false;
            state.error = null;
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
        },
        setError: (state, action: PayloadAction<string | null>) => {
            state.error = action.payload;
            state.loading = false;
        },
        addGroup: (state, action: PayloadAction<Group>) => {
            state.groups.unshift(action.payload);
        },
        updateGroupInList: (state, action: PayloadAction<Group>) => {
            const index = state.groups.findIndex((g) => g.id === action.payload.id);
            if (index !== -1) {
                state.groups[index] = action.payload;
            }
        },
        removeGroupFromList: (state, action: PayloadAction<string>) => {
            state.groups = state.groups.filter((g) => g.id !== action.payload);
        },
    },
});

export const {
    setGroups,
    setLoading,
    setError,
    addGroup,
    updateGroupInList,
    removeGroupFromList,
} = groupSlice.actions;
export default groupSlice.reducer;
